// extracted by mini-css-extract-plugin
module.exports = {"container":"Announcement_container__12Uez","marquee":"Announcement_marquee__xY6gX"};